module.exports = __webpack_public_path__ + "assets/img/14-s.4bba363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/14-s.jpg
// module id = fU0H
// module chunks = 0